import { render, staticRenderFns } from "./AiBookVersionConfig.vue?vue&type=template&id=19338204&scoped=true"
import script from "./AiBookVersionConfig.vue?vue&type=script&lang=js"
export * from "./AiBookVersionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19338204",
  null
  
)

export default component.exports